import React from 'react';

const DashboardSkeleton: React.FC = () => {
    return (
        <div className="animate-pulse space-y-8">
            {/* Header */}
            <div className="h-10 bg-brand-clay/10 rounded-xl w-64 mb-8"></div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="bg-white p-6 rounded-[2rem] border border-brand-clay/5 h-40 flex flex-col justify-between">
                        <div className="h-12 w-12 bg-brand-clay/10 rounded-full"></div>
                        <div className="space-y-2">
                            <div className="h-8 bg-brand-clay/10 rounded w-1/3"></div>
                            <div className="h-4 bg-brand-clay/10 rounded w-1/2"></div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Recent Orders Section */}
            <div className="bg-white rounded-[2rem] p-6 border border-brand-clay/5">
                <div className="h-8 bg-brand-clay/10 rounded-lg w-48 mb-6"></div>
                <div className="space-y-4">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="flex flex-col md:flex-row gap-4 p-4 border border-brand-clay/5 rounded-2xl">
                            <div className="w-20 h-20 bg-brand-clay/10 rounded-xl shrink-0"></div>
                            <div className="flex-1 space-y-3 py-2">
                                <div className="h-5 bg-brand-clay/10 rounded w-1/3"></div>
                                <div className="h-4 bg-brand-clay/10 rounded w-1/4"></div>
                            </div>
                            <div className="w-full md:w-32 h-10 bg-brand-clay/10 rounded-xl self-center"></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DashboardSkeleton;
